import React from "react";
import { SupportIntro } from "./SupportIntro";
import { Footer } from "../Footer";

export const SupportHome = () => {
  return (
    <div>
      <SupportIntro />
      <Footer color="#204350" />
    </div>
  );
};
